import { motion } from 'framer-motion';
import { MessageSquare } from 'lucide-react';

// Section for all businesses - new or established
export const StartEarlySection: React.FC = () => {

  return (
    <section
      className="relative py-24 sm:py-32 overflow-hidden bg-background"
      aria-label="Custom solutions"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left column - Text content */}
          <div className="text-center lg:text-left">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-6"
            >
              Start organized,
              <br />
              <span className="text-secondary">
                stay organized.
              </span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-lg sm:text-xl text-muted-foreground leading-relaxed mb-8"
            >
              Whether you're opening next month or have been running for years,
              Tag Inn brings clarity to your operations. The sooner you start,
              the sooner everything clicks into place.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="flex flex-col gap-3"
            >
              {['Works for new & established businesses', 'Quick setup, immediate clarity', 'Grow with confidence'].map((benefit, index) => (
                <div key={index} className="flex items-center gap-2.5 justify-center lg:justify-start">
                  <div
                    className="w-1.5 h-1.5 rounded-full"
                    style={{
                      backgroundColor: index === 0 ? 'var(--primary-hex)' : index === 1 ? 'var(--grow-hex)' : 'var(--secondary-hex)',
                    }}
                  />
                  <span className="text-sm sm:text-base font-medium text-foreground">
                    {benefit}
                  </span>
                </div>
              ))}
            </motion.div>
          </div>

          {/* Right column - Custom Solutions CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-center rounded-2xl border border-border/30 bg-card/50 p-8 sm:p-10"
          >
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-secondary/10 mb-6">
              <MessageSquare className="w-6 h-6 text-secondary" />
            </div>

            <h3 className="text-xl sm:text-2xl font-bold tracking-tight text-foreground mb-4">
              Need a custom solution?
            </h3>

            <p className="text-muted-foreground leading-relaxed mb-6">
              Table ordering, booking calendars, auto-repliers, and more.
              If you have specific needs, we can build it for you.
            </p>

            <motion.a
              href="#contact"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-secondary text-white font-medium hover:bg-secondary/90 transition-colors"
            >
              <MessageSquare className="w-4 h-4" />
              Get in touch
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
